import apiClient from './client';
import { Feedback } from '../types';

export const feedbackService = {
  // Get all feedbacks
  getAllFeedbacks: async (): Promise<Feedback[]> => {
    const response = await apiClient.get<Feedback[]>('/utils/feedback');
    return response.data;
  },

  // Update feedback status
  updateFeedbackStatus: async (feedbackId: number, status: 'OPEN' | 'RESOLVED'): Promise<void> => {
    await apiClient.patch(`/utils/feedback/${feedbackId}/status`, null, {
      params: { status },
    });
  },
};

